import axiosClient from "./axiosClient";
let { appname } = window.app;

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)));
}

// Stripe Connect endpoints identify the client from the session token alone. Sending
// a clientid (or emailid/phone) alongside it is worse than redundant: it was the whole
// vulnerability - the backend used to trust those identifiers over the session, so
// anyone could ask for another venue's onboarding link, Express dashboard login link
// or payout history just by changing the value. The backend now ignores them; don't
// send them.
//
// Every route into this flow runs after sign-in (signin.jsx, pwdGenerate.jsx and the
// unpaid-client redirect in contentContext.js all set a token before reaching
// /subscription -> /connectbankaccount), so a token is always available here.
function buildStripeConnectUrl(path) {
  const token = localStorage.getItem("token");

  let url = path + "?appname=" + appname;
  if (token) url += "&token=" + token;
  return url;
}

let subscription;
const notificationSub = async () => {
  const publicKey = 'BAEVgOD5lgDIQBECOE-f-hnsjDYeu7zmZilr0-P_98nK1Dm6sz3mgCjxACcxl-OtztT9AXc4YWZ77oA-E6ff7cg';
  const applicationServerKey = urlBase64ToUint8Array(publicKey);

  try {
    // Register service worker
   // const registration = await navigator.serviceWorker.register('/sw.js');

    // Check for existing subscription
    const existingSub = await window.registration.pushManager.getSubscription();

    if (existingSub) {
      // Compare keys
      const oldKey = existingSub.options.applicationServerKey;
      // console.log(oldKey)
      const oldKeyStr = oldKey
        ? btoa(String.fromCharCode(...new Uint8Array(oldKey)))
        : '';
      const newKeyStr = btoa(String.fromCharCode(...applicationServerKey));

      // If different, unsubscribe
      if (oldKeyStr !== newKeyStr) {
        // alert(1)
        console.warn('Old subscription key differs. Unsubscribing...');
        await existingSub.unsubscribe();
      } else {
        // console.log('Using existing valid subscription.');
        return existingSub;
      }
    }

    // Request notification permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Notification permission not granted.');
      return null;
    }

    // Subscribe with correct key
    subscription = await window.registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey,
    });

    // console.log('New subscription created:', subscription);
    return subscription;

  } catch (error) {
    console.error('Error subscribing for notifications:', error);
    return null;
  }
};
const tmdbApi = {
  websitedefaults: (params) => {
    const url = "/config?" + 'appname=' + appname;
    return axiosClient.get(url, params);
  },

  appMenus: (params) => {
    const url = "/menus?" + 'appname=' + appname + '&appType=client&page=landingpage';
    return axiosClient.get(url, params);
  },

  signin: async (params) => {
    if (!subscription) {
      subscription = await notificationSub()
    }
    params["notificationSubscription"] = subscription
    const url = "/signin?appname=" + appname;
    return axiosClient.post(url, params);
  },
  UserSignin: (params) => {
    const url = "/userSignin?appname=" + appname;
    return axiosClient.post(url, params);
  },


  signOtp: async (params) => {
    if (!subscription) {
      subscription = await notificationSub()
    }
    params["notificationSubscription"] = subscription
    const url = "/signin?appname=" + appname + "&type=signin";
    return axiosClient.post(url, params);
  },

  CreatePassword: (params) => {
    const url = "/userSetPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },

  ForgotPassword: (params) => {
    const url = "/adminForgotPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },
  ClientForgotPassword: (params) => {
    const url = "/forgotPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },

  Adduser: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/user?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },


  getContent: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/content?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  dataImport: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/importData?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  getCompany: (params) => {
    const token = localStorage.getItem("token")
    const url = "/companies?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },

  SaveClient: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addClient?appname=" + appname + '&userid=' + userid
    // + "&token=" + token;
    return axiosClient.put(url, params);
  },
  SaveClientData: (params) => {
    const payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/client?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.put(url, payload);
  },
  FollowUp: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/followup?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },
  AddClient: (params) => {
    // const token = localStorage.getItem("token")
    // const userid = localStorage.getItem("userId")
    const url = "/signUp?appname=" + appname;
    return axiosClient.post(url, params);
  },
  ChangeEmail: (params) => {
    // const token = localStorage.getItem("token")
    // const userid = localStorage.getItem("userId")
    const url = "/emailChange?appname=" + appname;
    return axiosClient.post(url, params);
  },
  ChangePhone: (params) => {
    // const token = localStorage.getItem("token")
    // const userid = localStorage.getItem("userId")
    const url = "/phoneChange?appname=" + appname;
    return axiosClient.post(url, params);
  },
  dashboard: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/analytics?appname=" + appname + "&token="+token +"&clientid="+clientid;
    return axiosClient.post(url, params);
  },
   getStatstics: (params) => {
    const payload = params
    // console.log("payload",payload)
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    let url;
    if(payload.hasOwnProperty('storeid')){
      url = "/statstics?appname=" + appname + "&token="+token +"&clientid="+clientid +"&storeid="+params.storeid;
    }else{
      url = "/statstics?appname=" + appname + "&token="+token +"&clientid="+clientid;
    }
     if (payload.hasOwnProperty('storeid')) delete payload['storeid']
    return axiosClient.post(url, payload);
  },
  getCounts: (params) => {
    // const token = localStorage.getItem("token")
    // const userid = localStorage.getItem("userId")
    const clientid = localStorage.getItem("clientid")
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const url = "/counts?appname=" + appname +"&clientid="+clientid +"&timeZone="+timeZone;
    return axiosClient.post(url, params);
  },
  resendMail: (params) => {
    let payload = params
    let url = "/resendMail?appname=" + appname;
    // if (payload.hasOwnProperty('page')) delete payload['page']

    return axiosClient.post(url, payload);
  },
  resendMailSignin: (params) => {
    let payload = params
    let url = "/resendMail?appname=" + appname + "&type=signin";
    // if (payload.hasOwnProperty('page')) delete payload['page']

    return axiosClient.post(url, payload);
  },
  otpVerify: async (params) => {
    if (!subscription) {
      subscription = await notificationSub()
    }
    params["notificationSubscription"] = subscription
    let payload = params
    let url = "/otpVerify?appname=" + appname;
    // if (payload.hasOwnProperty('page')) delete payload['page']

    return axiosClient.post(url, payload);
  },
  AddCompany: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/company?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },

  getAccount: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/accountmangers?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.get(url, params);
  },

  getCategory: (params) => {
    const token = localStorage.getItem("token")
    // const url = "/category?appname=" + appname + "&token=" + token +"&status=ACTIVE";
    const url = "/category?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },

  getLookUp: (params) => {
    const token = localStorage.getItem("token")

    let payload = params
    let projection = params?.projection ? params?.projection : "";
    let status = params?.status ? params?.status : "";
    let url = "/lookups?appname=" + appname;
    //   if (token) {
    //     url += `&token=${token}`;
    // }
    if (projection !== "") { url = url + `&projection=tiny` }
    if (status !== "") { url = url + `&status=ACTIVE` }

    if (payload.hasOwnProperty('projection')) delete payload['projection']
    if (payload.hasOwnProperty('status')) delete payload['status']

    return axiosClient.post(url, payload);

  },

  getUserData: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/users?appname=" + appname + '&token=' + token;
    return axiosClient.post(url, params);
  },
  getClientData: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/clientInfo?appname=" + appname + "&clientid=" + clientid + "&token=" + token;
    // + "&token=" + token;
    return axiosClient.get(url, params);
  },
  getClientUserData: (params) => {
    const token = localStorage.getItem("token");
    const clientid = localStorage.getItem("clientid");

    // Start building the URL
    let url = `/clientUserInfo?appname=${appname}&clientid=${clientid}`;

    // Conditionally append token if it exists
    if (token) {
      url += `&token=${token}`;
    }

    return axiosClient.get(url, { params });
  },

  getClientInfo: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/clientInfo?appname="+ appname +"&clientid="+clientid;
    // + "&token=" + token;
    return axiosClient.get(url, params);
  },
  getNotifications: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/notificationsbyclient?appname="+ appname +"&clientid="+clientid
    // + "&token=" + token;
    return axiosClient.get(url, params);
  },
  readNotification: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/readNotification?appname="+ appname 
    // + "&token=" + token;
    return axiosClient.post(url, params);
  },
  getScheduled: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/scheduled?appname="+ appname 
    // + "&token=" + token;
    return axiosClient.get(url, params);
  },
  getAdminData: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/userInfo?appname=" + appname + "&userid=" + userid;
    return axiosClient.get(url, params);
  },
  filterCategory: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    //let pageNumber = params.pageNumber || 1;
    //    let assetcount = params.assetcount || 10;
    // let cat = params.category || "";
    let url = "/content?appname=" + appname + "&token=" + token + '&userid=' + userid;
    // if( pageNumber !== "") { url = url + `&pageNumber=${pageNumber}`}
    // if( assetcount !== "") {url = url + `&assetcount=${assetcount}`}
    return axiosClient.post(url, params);

  },

  AdminUpdateApi: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateUser?appname=" + appname + "&userid=" + userid;
    // + "&token=" + token;
    return axiosClient.post(url, params);
  },

  ClientUpdateApi: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/updateClient?appname=" + appname + "&clientid=" + clientid;
    //  "&token=" + token;
    return axiosClient.post(url, params);
  },
  ClientUserUpdateApi: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/clientUpdateUser?appname=" + appname + "&clientid=" + clientid + "&token=" + token;
    //  "&token=" + token;
    return axiosClient.post(url, params);
  },
  pwdGenerate: async(params) => {
    if (!subscription) {
      subscription = await notificationSub()
    }
    params["notificationSubscription"] = subscription
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/setPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },
  UserPwdGenerate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/userChangePassword?appname=" + appname + "&userid=" + userid + "&token=" + token;
    return axiosClient.post(url, params);
  },

  clientSearch: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientSearch?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  AllDeals: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientEnquiry?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  UpdateDeals: (params) => {
    let payload = params;
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientEnquiry?appname=" + appname + "&enquiryid=" + params.enquiryid + "&token=" + token + '&userid=' + userid;
    if (payload.hasOwnProperty('enquiryid')) delete payload['enquiryid']
    return axiosClient.put(url, payload);
  },

  UpdateFollowupDeals: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/enquiryFollowup?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  AddDeal: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/clientEnquiry?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  AddLead: (params) => {

    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const payload = { ...params }
    const url = "/addLead?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, payload);
  },
  NotifyAdmin: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/notifyAdmin?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.post(url, params);
  },
  AddConversation: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addConversation?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.put(url, payload);
  },
  GetConversations: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/conversations?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    return axiosClient.get(url, payload);
  },
  UpdateConvData: (params) => {
    const payload = params
    const token = localStorage.getItem("token")
    const url = "/updateConversation?appname=" + appname + "&token=" + token + "&conversationid=" + params.conversationid + "&status=" + params.status;
    if (payload.hasOwnProperty('status')) delete payload['status']
    if (payload.hasOwnProperty('conversationid')) delete payload['conversationid']
    return axiosClient.post(url, payload);
  },
  UpdateLead: (params) => {
    const payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateLead?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid + '&clientid=' + params.clientid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    if (payload.hasOwnProperty('clientid')) delete payload['clientid']
    return axiosClient.post(url, payload);
  },
  GetConversationComments: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addConversationComment?appname=" + appname + "&token=" + token + '&userid=' + userid + '&conversationid=' + params.conversationid;
    if (payload.hasOwnProperty('conversationid')) delete payload['conversationid']
    return axiosClient.post(url, payload);
  },
  GetConversationsCommentData: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateconversationComment?appname=" + appname + "&token=" + token + '&userid=' + userid + '&commentid=' + params.leadid;
    return axiosClient.get(url, payload);
  },
  GetLeads: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/leads?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.get(url, params);
  },

  GetSellers: (params) => {
    const token = localStorage.getItem("token")
    const url = "/companyList?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },


  GetBuyers: (params) => {
    const token = localStorage.getItem("token")
    const url = "/blockCompanyList?appname=" + appname + "&token=" + token + "&companyid=" + params.id;
    return axiosClient.get(url, params);
  },

  GetBlockBuyers: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/getblockCompanies?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  SignOutClient: (params, value) => {
    let payload = params
    // console.log('params', params);
    // console.log('value', value);
    // const url = "/signout?appname="+appname+"&emailid="+params.emailId;
    const url = "/signout?appname=" + appname;
    return axiosClient.post(url, payload);
  },

  SignOutUser: (params, value) => {
    let payload = params
    // console.log('params', params);
    // console.log('value', value);

    // const url = "/signout?appname="+appname+"&emailid="+params.emailId;
    const url = "/userSignout?appname=" + appname;
    return axiosClient.post(url, payload);
  },
  mapImport: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/importDataV2?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  getBiddingLookUp: (params) => {
    const token = localStorage.getItem("token")
    let payload = params

    let status = params?.status ? params?.status : "";
    let url = "/biddingLookups?appname=" + appname + "&token=" + token;
    if (status !== "") { url = url + `&status=ACTIVE`; }
    if (payload.hasOwnProperty('status')) delete payload['status']
    return axiosClient.post(url, payload);
  },

  Subscribe: (params) => {
    const url = "/registerNotification?appname=" + appname;
    return axiosClient.post(url, params);
  },

  getTransactionCounts: () => {
    const token = localStorage.getItem("token");
    const clientid = localStorage.getItem("clientid");
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const url = "/transactionCounts?appname=" + appname + "&timezone=" + encodeURIComponent(timeZone) + "&token=" + token + "&clientid=" + clientid;
    return axiosClient.get(url);
  },

  getTransactionAnalytics: (params) => {
    const payload = { ...params };
    const token = localStorage.getItem("token");
    const clientid = localStorage.getItem("clientid");
    let url = "/transactionAnalytics?appname=" + appname + "&token=" + token + "&clientid=" + clientid;
    if (payload.storeid) {
      url += "&storeid=" + payload.storeid;
      delete payload.storeid;
    }
    return axiosClient.post(url, payload);
  },

  getTransactionList: (params) => {
    const payload = { ...params };
    const token = localStorage.getItem("token");
    const clientid = localStorage.getItem("clientid");
    let url = "/transactionList?appname=" + appname + "&token=" + token + "&clientid=" + clientid;
    if (payload.storeid) {
      url += "&storeid=" + payload.storeid;
      delete payload.storeid;
    }
    return axiosClient.post(url, payload);
  },

  // Creates the client's Stripe Connect (Express) account on first call, or mints a
  // fresh onboarding link on later calls if the client hasn't finished / needs to
  // update their info. Backend response shape: { stripeAccountId, onboardingUrl }.
  //
  // NOTE: this can run right after signup/OTP-verify, before the client has ever
  // signed in - at that point there's no clientid/token in localStorage yet, only
  // emailid/phone (see signUp.jsx). So we send whichever identifiers we have and
  // let the backend resolve the client from them.
  createStripeConnectOnboarding: (params = {}) => {
    const url = buildStripeConnectUrl("/stripeConnectOnboarding");
    return axiosClient.post(url, params);
  },

  // Backend should not trust the return_url redirect alone - it should look up the
  // connected account via the Stripe API and report its real status here.
  // Response shape: { stripeAccountId, status, onboardingCompleted, detailsSubmitted, chargesEnabled,
  // payoutsEnabled, bankConnected, bankName, bankLast4, disabledReason, requirementsDue,
  // eventuallyDue, currentDeadline }. requirementsDue = Stripe has paused payouts over these;
  // eventuallyDue = it will ask for these at a volume threshold (nudge now, pause later).
  getStripeConnectStatus: (params = {}) => {
    const url = buildStripeConnectUrl("/stripeConnectStatus");
    return axiosClient.get(url, { params });
  },

  // For a client who already has a connected Stripe account: mints a Stripe Express
  // Dashboard login link (single-use, short-lived) so they can update/replace their
  // bank account, view payout history, etc. directly in Stripe's own UI - no separate
  // "edit bank details" flow needed on our side. Response shape assumed: { loginUrl }.
  // Pass { stripeAccountId } when the caller already has it (e.g. from
  // getStripeConnectStatus) - the backend verifies it against the client's own
  // record rather than trusting it outright, and resolves it itself if omitted.
  getStripeLoginLink: (params = {}) => {
    const url = buildStripeConnectUrl("/stripeConnectLogin");
    return axiosClient.get(url, { params });
  },

  // The backend answers a missing/unknown/idle session with this string as the RESULT
  // (not an error) - the same signal the list pages already match on to show their
  // sign-in popup. It matters most for the Connect *status* calls: an expired session
  // says nothing about whether a bank account exists, so treating it as a status object
  // reads as "not connected" and would nag - or worse, block the paid-plan save in
  // editStore - a client whose bank is connected and whose session merely went stale.
  isSessionExpired: (response) =>
    (response?.result || response) === "Invalid token or Expired",

};



export default tmdbApi;
